import React from 'react';

interface IProps {
    size: number;
    className?: string;
}

const IconInfo = (props: IProps) => {
    return (
        <div className={props?.className} style={{ height: `${props.size}px` }}>
            <svg
                width={`${props.size}px`}
                height={`${props.size}px`}
                version="1.1"
                viewBox="0 0 1200 1200"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g>
                    <path
                        d="m746.83 855.59c-25.379 97.887-282.78 105.14-264.65-25.379 10.875-87.008 29.004-170.39 43.504-257.4 7.25-54.379-29.004-36.254-58.008-47.129-21.754-10.875-21.754-36.254 3.625-39.879 32.629-7.25 145.02-3.625 184.89-3.625 21.754 0 32.629 10.875 32.629 29.004 3.625 18.125 0 36.254-3.625 50.754-14.5 83.383-36.254 170.39-43.504 250.15-3.625 18.125 0 50.754 25.379 50.754 25.379-3.625 36.254-14.5 58.008-21.754 14.5-7.25 21.754 3.625 21.754 14.5z"
                        fillRule="evenodd"
                    />
                    <path
                        d="m619.94 268.28c50.754 0 87.008 39.879 87.008 87.008 0 50.754-39.879 90.633-87.008 87.008-47.129 0-87.008-39.879-87.008-87.008s39.879-87.008 87.008-87.008z"
                        fillRule="evenodd"
                    />
                    <path d="m598.19 0c333.54 0 601.81 268.28 601.81 598.19 0 333.54-268.28 601.81-601.81 601.81-329.91 0-598.19-268.28-598.19-601.81 0-329.91 268.28-598.19 598.19-598.19zm0 90.633c-279.15 0-507.55 228.4-507.55 507.55 0 282.78 228.4 507.55 507.55 507.55 282.78 0 507.55-224.77 507.55-507.55 0-279.15-224.77-507.55-507.55-507.55z" />
                </g>
            </svg>
        </div>
    );
};

export default IconInfo;
